export const computeTableChange = (tableObj, tableType, valueType, value, tableTotal, duration, replaceAmtSw ) => {
   
    let amountName = "";
    switch (tableType){
        case "asset":
            amountName = "assetAmt";
            break;
        case "expense":
            amountName = "expAmount";
            break;
        case "loan":
            amountName = "loanAmt";
            break;
        default:
            break;
    }
    let revisedAmt = 0;
    if (Object.keys(tableObj).length !== 0){
        if (valueType === "percent"){
            revisedAmt = (+tableObj[amountName] * (+value/100)).toFixed(2);
            revisedAmt = revisedAmt.toString();
        }else{
            if (replaceAmtSw === true){
                revisedAmt = (+value - +tableObj[amountName]).toString();
            }else{
                revisedAmt = (+value).toString();
            }
        }   
    }else{
        revisedAmt = +value.toString();
    }

    let cashChg = 0;
    let newTableTotal = tableTotal;
    if (duration === "1"){
        cashChg = revisedAmt;
    }else{
        cashChg = 0;
        newTableTotal = (+newTableTotal + +revisedAmt).toFixed(2);
        newTableTotal = newTableTotal.toString();
    }
    const returnObj = {tableType: tableType, newTableTotal: newTableTotal, revisedAmt: revisedAmt,
        cashChg: cashChg};
    return returnObj;
    
 }
 export default computeTableChange;